export function ImportIcon(): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M9.82999 12H11V18H13V12H14.17L12 9.83L9.82999 12Z"
        fill="currentColor"
      />
      <path
        d="M5 4H19V6H5V4ZM12 7L5 14H9V20H15V14H19L12 7ZM13 12V18H11V12H9.83L12 9.83L14.17 12H13Z"
        fill="currentColor"
      />
    </svg>
  );
}
